// Per-customer contract / agreement records owned by a partner.
// Backed by aitryx-core PartnerCustomerContracts + PartnerCustomerContractFiles.

export interface ContractFile {
  id: string
  contractId: string
  fileName: string
  contentType: string
  fileSize: number
  blobContainer: string
  blobPath: string
  createdAt: string
  uploadedByUserId?: string
}

export interface Contract {
  id: string
  partnerId: string
  customerId: string
  contractType: string         // 'MSA' | 'SOW' | 'Quote' | 'NDA' | 'Other'
  title: string
  vendor?: string | null
  annualValue?: number | null
  currency?: string | null     // ISO 4217 e.g. 'AUD'
  startDate?: string | null    // YYYY-MM-DD (DateOnly serialised)
  endDate?: string | null
  renewalDate?: string | null
  autoRenew: boolean
  status: string               // 'Active' | 'Expired' | 'Pending' | 'Cancelled'
  notes?: string | null
  createdAt: string
  updatedAt: string
  createdByUserId?: string | null
  isActive: boolean
  // Present on list responses (not the full record):
  fileCount?: number
  // Present on detail responses:
  files?: ContractFile[]
}

export interface CreateContractRequest {
  title: string
  contractType: string
  vendor?: string
  annualValue?: number
  currency?: string
  startDate?: string
  endDate?: string
  renewalDate?: string
  autoRenew?: boolean
  status?: string
  notes?: string
}

export interface UpdateContractRequest {
  title?: string
  contractType?: string
  vendor?: string | null
  annualValue?: number | null
  currency?: string | null
  startDate?: string | null
  endDate?: string | null
  renewalDate?: string | null
  autoRenew?: boolean
  status?: string
  notes?: string | null
}

export const CONTRACT_TYPES = [
  { value: 'MSA',   label: 'Master Service Agreement' },
  { value: 'SOW',   label: 'Statement of Work' },
  { value: 'Quote', label: 'Quote' },
  { value: 'NDA',   label: 'Non-Disclosure Agreement' },
  { value: 'Other', label: 'Other' },
] as const

export const CONTRACT_STATUSES = [
  { value: 'Active',    label: 'Active' },
  { value: 'Expired',   label: 'Expired' },
  { value: 'Pending',   label: 'Pending' },
  { value: 'Cancelled', label: 'Cancelled' },
] as const
